import React, { useEffect, useState } from "react";
import Modal from "@mui/material/Modal";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import HighlightOffIcon from "@mui/icons-material/HighlightOff";
import TextField from "@mui/material/TextField";
import Select from "@mui/material/Select";
import MenuItem from "@mui/material/MenuItem";
import InputLabel from "@mui/material/InputLabel";
import FormControl from "@mui/material/FormControl";
import Checkbox from "@mui/material/Checkbox";
import FormHelperText from "@mui/material/FormHelperText";
import LoadingButton from "@mui/lab/LoadingButton";
import AddAPhotoIcon from "@mui/icons-material/AddAPhoto";
import DeleteOutlineIcon from "@mui/icons-material/DeleteOutline";
import IconButton from "@mui/material/IconButton";
import { useForm, Controller } from "react-hook-form";
import { CATEGORIES, REGIONS, DEFAULT_VALUES } from "./data";
import { useDispatch, useSelector } from "react-redux";
import { toast } from "react-toastify";
import { addPlaceStart, clearAddPlace } from "../../store/place/reducer";
import { nanoid } from "@reduxjs/toolkit";
import * as colors from "@mui/material/colors";

export const AddPlace = ({ isOpen, onClose, coordinate }) => {
  const dispatch = useDispatch();
  const [images, setImages] = useState([]);
  const { addPlaceLoading, addPlaceSuccess } = useSelector(
    (state) => state.place
  );
  const {
    control,
    handleSubmit,
    reset,
    formState: { errors },
  } = useForm({
    defaultValues: DEFAULT_VALUES,
  });

  useEffect(() => {
    if (addPlaceSuccess) {
      toast.info("Place added successfully", {
        position: "bottom-right",
        autoClose: 3000,
        hideProgressBar: true,
        closeOnClick: true,
        closeButton: false,
      });
      dispatch(clearAddPlace());
      reset(DEFAULT_VALUES);
      setImages([]);
      onClose();
    }
  }, [addPlaceSuccess]);

  const handleFileChange = (event) => {
    const reader = new FileReader();
    const file = event.target.files[0];

    reader.onload = (readerEvent) => {
      if (file.type.includes("image")) {
        setImages((prev) => [
          ...prev,
          {
            id: nanoid(),
            preview: readerEvent.target.result,
            file,
          },
        ]);
      }
    };

    if (file) {
      reader.readAsDataURL(file);
    }
  };

  const handleRemove = (id) => {
    setImages((prev) => prev.filter((item) => item.id !== id));
  };

  const onSubmit = (data) => {
    const formData = new FormData();
    for (const key in data) {
      formData.append(key, data[key]);
    }

    formData.append("building_l", coordinate[1]);
    formData.append("building_1", coordinate[0]);

    // console.log("tttt", formData.append("building_l", coordinate[1]));


    for (const image of images) {
      formData.append("image", image.file);
    }
    dispatch(
      addPlaceStart({
        place: formData,
      })
    );
  };
  return (
    <Modal open={isOpen} onClose={onClose}>
      <Box
        sx={{
          position: "absolute",
          top: "50%",
          left: "50%",
          transform: "translate(-50%, -50%)",
          width: 400,
          bgcolor: "background.paper",
          p: 4,
          borderRadius: 1,
        }}
      >
        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
            gap: "20px",
          }}
        >
          <Box
            sx={{
              display: "flex",
              flexDirection: "row",
              justifyContent: "space-between",
              alignItems: "center",
            }}
          >
            <Typography variant="h6" component="h2">
              Add a Place
            </Typography>
            <div onClick={onClose} style={{ cursor: "pointer" }}>
              <HighlightOffIcon />
            </div>
          </Box>

          <Controller
            name="name_eng"
            control={control}
            rules={{
              required: {
                value: true,
                message: "name english is requried",
              },
            }}
            render={({ field }) => (
              
              
              <TextField
                {...field}
                label="Name in English"
                variant="standard"
                sx={{
                  width: "100%",
                }}
                helperText={errors.name_eng && errors.name_eng.message}
                error={!!errors.name_eng}
              />

            )}
          />
          <Controller
            name="legal_name"
            control={control}
            rules={{
              required: {
                value: true,
                message: "Legal name is requried",
              },
            }}
            render={({ field }) => (
              
              
              <TextField
                {...field}
                label="Name in Amharic"
                variant="standard"
                sx={{
                  width: "100%",
                }}
                helperText={errors.legal_name && errors.legal_name.message}
                error={!!errors.legal_name}
              />

            )}
          />
          <Controller
            name="legal_na_2"
            control={control}
            rules={{
              required: {
                value: true,
                message: "local language  is requried",
              },
            }}
            render={({ field }) => (
              
              
              <TextField
                {...field}
                label="Name in Local Language"
                variant="standard"
                sx={{
                  width: "100%",
                }}
                helperText={errors.legal_na_2 && errors.legal_na_2.message}
                error={!!errors.local_na_2}
              />

            )}
          />
          <Controller
            name="fun_type"
            control={control}
            rules={{
              required: {
                value: true,
                message: "Category is requried",
              },
            }}
            render={({ field }) => (
              <FormControl
                variant="standard"
                error={!!errors.function_t}
                fullWidth
              >
                <InputLabel id="category-label">Category</InputLabel>
                <Select
                  {...field}
                  labelId="category-label"
                  label="Select Category"
                >
                  {CATEGORIES.map((category) => (
                    <MenuItem key={category.id} value={category.id}>
                      {category.label}
                    </MenuItem>
                  ))}
                </Select>
                <FormHelperText>
                  {errors.function_t && errors.function_t.message}
                </FormHelperText>
              </FormControl>
            )}
          />
          <Controller
            name="region"
            control={control}
            rules={{
              required: {
                value: true,
                message: "Region is requried",
              },
            }}
            render={({ field }) => (
              <FormControl variant="standard" error={!!errors.region} fullWidth>
                <InputLabel id="category-label">Region</InputLabel>
                <Select
                  {...field}
                  labelId="category-label"
                  label="Select Category"
                >
                  {REGIONS.map((region) => (
                    <MenuItem key={region.id} value={region.id}>
                      {region.label}
                    </MenuItem>
                  ))}
                </Select>
                <FormHelperText>
                  {errors.region && errors.region.message}
                </FormHelperText>
              </FormControl>
            )}
          />

          <Controller
            name="city_name"
            control={control}
            rules={{
              required: {
                value: true,
                message: "City name is requried",
              },
            }}
            render={({ field }) => (
              <TextField
                {...field}
                label="City Name"
                variant="standard"
                sx={{
                  width: "100%",
                }}
                helperText={errors.city_name && errors.city_name.message}
                error={!!errors.city_name}
              />
            )}
          />

          <Controller
            name="village_na"
            control={control}
            render={({ field }) => (
              <TextField
                {...field}
                label="Village Name"
                variant="standard"
                sx={{
                  width: "100%",
                }}
              />
            )}
          />
          <Controller
            name="website"
            control={control}
            render={({ field }) => (
              <TextField
                {...field}
                label="Website"
                variant="standard"
                sx={{
                  width: "100%",
                }}
                helperText={errors.website && errors.website.message}
                error={!!errors.website}
              />
            )}
          />
          <Controller
            name="contactInfo"
            control={control}
            render={({ field }) => (
              <TextField
                {...field}
                label="Contact Info"
                variant="standard"
                sx={{
                  width: "100%",
                }}
                helperText={errors.contactInfo && errors.contactInfo.message}
                error={!!errors.contactInfo}
              />
            )}
          />
          <IconButton
            color="primary"
            component="label"
            sx={{
              alignSelf: "flex-start",
              borderWidth: "1px",
              borderRadius: "10px",
              borderColor: "#cccccc",
              borderStyle: "solid",
              padding: "15px",
              display: "flex",
              flexDirection: "column",
              gap: "10px",
            }}
          >
            <input
              hidden
              accept="image/*"
              type="file"
              onChange={handleFileChange}
              multiple={false}
            />
            <AddAPhotoIcon
              sx={{
                width: "30px",
                height: "30px",
                color: "#04B2B2",
              }}
            />
            <Typography variant="caption" sx={{ color: "#909090" }}>
              Add a Picture
            </Typography>
          </IconButton>
          <Box
            sx={{
              display: "flex",
              flexDirection: "row",
              flexWrap: "wrap",
              gap: "10px",
            }}
          >
            {images.map((image) => (
              <Box
                key={image.id}
                sx={{
                  width: "60px",
                  height: "60px",
                  position: "relative",
                  borderRadius: "8px",
                  overflow: "hidden",
                }}
              >
                <img
                  src={image.preview}
                  alt={image.file.name}
                  style={{
                    width: "100%",
                    height: "100%",
                  }}
                />
                <div
                  style={{
                    position: "absolute",
                    top: "30%",
                    left: "30%",
                    cursor: "pointer",
                  }}
                  onClick={() => handleRemove(image.id)}
                >
                  <DeleteOutlineIcon
                    sx={{
                      color: colors.red[700],
                    }}
                  />
                </div>
              </Box>
            ))}
          </Box>
          <Controller
            name="parking_fa"
            control={control}
            render={({ field }) => (
              <Box sx={{ display: "flex", alignItems: "center", gap: "6px" }}>
                <Checkbox {...field} />
                <Typography variant="body2">Is parking available?</Typography>
              </Box>
            )}
          />

          <LoadingButton
            color="primary"
            sx={{
              backgroundColor: "#04B2B2",
              color: "#FFFFFF",
              "&:hover": {
                backgroundColor: "#04B2B2",
              },
            }}
            loading={addPlaceLoading}
            onClick={handleSubmit(onSubmit)}
          >
            Submit
          </LoadingButton>
        </Box>
      </Box>
    </Modal>
  );
};
